import {CertificatesListSearchComponent} from './CertificatesListSearchComponent'

const CertificatesListHeader = () => {
    
    return (
    <div className='card-header border-0 pt-6 d-flex flex-column mb-8'>
        <h1>Certificate of Conformity Directory</h1>
        <CertificatesListSearchComponent />
    </div>
    )
}

export {CertificatesListHeader}
